import { gql, useMutation } from '@apollo/client'
import { useEffect, useState } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import Heading from 'components/v2/Heading'
import FormLayout from 'features/App/components/FormLayout'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { NewCombo } from 'features/Snacks/components/NewCombo'
import { messages as fileMessages } from 'messages/file'
import { usePushFileToS3 } from 'utils/file'
import { sanitizePrice } from 'utils/math'
import { canWrite } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'

const messages = defineMessages({
  helmet: {
    id: 'combos.new.helmet',
    defaultMessage: 'New Combo | Nexbus Admin'
  }
})

const REGISTER_ITEM = gql`
  mutation RegisterItemCombo($combo: RegisterItemComboInput!) {
    registerItemCombo(input: $combo)
  }
`

const NewComboView = (): TSFixMe => {
  const navigate = useNavigate()
  const intl = useIntl()
  const [s3Error, setS3Error] = useState()
  const login = useLogin()

  useEffect((): TSFixMe => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  const [registerItem, { loading, error }] = useMutation(REGISTER_ITEM, {
    onCompleted() {
      navigate('/snacks/combos')
    }
  })
  const pushFileToS3 = usePushFileToS3()

  const handleSubmit = async (combo: TSFixMe): Promise<TSFixMe> => {
    // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
    setS3Error()
    const payload = {
      name: combo.name,
      category: combo.category,
      subcategory: combo.subcategory || null,
      sellingPrice: sanitizePrice(combo.sellingPrice * 100, true),
      minSellingPrice: combo.minSellingPrice ? sanitizePrice(combo.minSellingPrice * 100, true) : null,
      components: combo.components.map((component: TSFixMe): TSFixMe => {
        return {
          quantity: parseInt(component.quantity),
          eligibleItemIDs: component.eligibleItems.map(({ id }: TSFixMe): TSFixMe => id)
        }
      })
    }

    try {
      if (!combo.photo) {
        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
        payload.photoPath = null
      } else {
        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
        payload.photoPath = await pushFileToS3(combo.photo)
      }
    } catch (ex) {
      // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
      setS3Error(intl.formatMessage(fileMessages.uploadFileError, { count: 1 }))
      return
    }

    registerItem({
      variables: {
        combo: payload
      }
    })
  }

  if (!canWrite(FEATURES.ITEM, login.accessToken.policies)) {
    return <ForbiddenView feature={FEATURES.ITEM} />
  }

  return (
    <div>
      <FormLayout.Header>
        <Heading.H3>
          <FormattedMessage id="spanish.combos.new.title" defaultMessage="Agregar combo" />
        </Heading.H3>
      </FormLayout.Header>
      <FormLayout.Content>
        <NewCombo
          onSubmit={handleSubmit}
          companyId={login.accessToken.companyId}
          loading={loading}
          error={error}
          s3Error={s3Error}
        />
      </FormLayout.Content>
    </div>
  )
}

export default withLastUrl(NewComboView)
